import Component from "@glimmer/component";
import { inject as service } from "@ember/service";

export default class LoadingSliderFallbackSpinner extends Component {
  @service loadingSlider;
}
